<template>
  <a-modal
    title="转月"
    :width="680"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok', param) }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item :label="turnedMonthFuturesContractLabel">
              <a-month-picker
                v-decorator="['futures_contract', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM"
                placeholder="期货合约"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
            <a-form-item :label="turnedMonthLockUpDateLabel">
              <a-date-picker
                v-decorator="['lock_up_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="锁价期限"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
            <a-form-item :label="turnedMonthPricingPeriodLabel">
              <a-range-picker
                @change="time"
                format="YYYY-MM-DD"
                style="width: 100%"
                v-decorator="['pricing_period', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                <template slot="dateRender" slot-scope="current">
                  <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                    {{ current.date() }}
                  </div>
                </template>
              </a-range-picker>
            </a-form-item>
            <a-form-item :label="isTruningMonthLabel" v-if="false">
              <a-switch @change="turningMonthChange" v-decorator="['is_turning_month', { initialValue: false, valuePropName: 'checked' }]" checked-children="是" un-checked-children="否"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'

// 表单字段
const fields = ['is_turning_month']
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      isTurningMonth: false,
      param: {},
      size: 0,
      form: this.$form.createForm(this)
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
    this.size = this.model['size']
    console.log('-----size', this.model)
  },
  computed: {
    turnedMonthFuturesContractLabel () {
      if (this.size === 0) {
        return '转月后期货合约'
      } else if (this.size === 1) {
        return '二次转月后期货合约'
      } else {
        return (this.size + 1) + '次转月后期货合约'
      }
    },
    turnedMonthPricingPeriodLabel () {
      if (this.size === 0) {
        return '转月后默认计价期'
      } else if (this.size === 1) {
        return '二次转月后默认计价期'
      } else {
        return (this.size + 1) + '次转月后默认计价期'
      }
    },
    turnedMonthLockUpDateLabel () {
      if (this.size === 0) {
        return '转月后锁价期限'
      } else if (this.size === 1) {
        return '二次转月后锁价期限'
      } else {
        return (this.size + 1) + '次转月后锁价期限'
      }
    },
    isTruningMonthLabel () {
      if (this.size === 0) {
        return '是否可转月'
      } else if (this.size === 1) {
        return '是否可二次转月'
      } else {
        return '是否可' + (this.size + 1) + '次转月'
      }
    }
  },
  methods: {
    turningMonthChange (v) {
      this.isTurningMonth = v
    },
    time (dates, dateStrings) {
      console.log(dateStrings, '时间')
      this.param.start_date = dateStrings[0]
      this.param.end_date = dateStrings[1]
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    }
  }
}
</script>
